/*
* <license header>
*/

import React from 'react'
import { View } from '@adobe/react-spectrum'
import { Header } from './home/Header'
import { KeyFeaturesSection } from './home/KeyFeaturesSection'
import { PlatformStatistics } from './home/PlatformStatistics'
import { ExploreByCategorySection } from './home/ExploreByCategorySection'
import { FeaturedContentSection } from './home/FeaturedContentSection'
import { AboutSection } from './home/AboutSection'

export const Home = () => (
  <div className="Home-content">
  <View width="100%" padding="size-400" UNSAFE_style={{ paddingBottom: '2.5rem' }}>
    <Header />
    <KeyFeaturesSection />
    <PlatformStatistics />
    <ExploreByCategorySection />
    <FeaturedContentSection />
    <AboutSection />
  </View>
  </div>
)
